export default __webpack_public_path__ + "static/media/Nutzungsbedingungen.a3a1836a.pdf";